import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const deactivateBadge = (badgeNumber: string): AxiosPromise =>
  instance.put(`/api/badges/${badgeNumber}/deactivate`);

export default deactivateBadge;
